module.exports = __webpack_public_path__ + "static/mobile_title-746ad38b81242cb77907f0493b7d5926.png";